import type { RichBlock, RichDoc, RichInline } from './types';
import { createBlockIds } from './ids';
import { isNode, placePlateBlock } from './from-plate';
import type { PlateListEntry } from './from-plate';
import { isRichBlock, richBlock } from './from-rich';

export type { RichBlock, RichBlockType, RichDoc, RichInline, RichObjectKind, RichStyleName, RichTable } from './types';

export function richDocFrom(value: unknown): RichDoc {
  if (!Array.isArray(value)) {
    return [];
  }
  const ids = createBlockIds();
  const out: RichBlock[] = [];
  let stack: PlateListEntry[] = [];
  for (const node of value) {
    if (!isNode(node)) {
      continue;
    }
    if (isRichBlock(node)) {
      out.push(richBlock(node, ids));
      stack = [];
    } else {
      stack = placePlateBlock(node, ids, out, stack);
    }
  }
  return out;
}

export function richParagraph(text: string): RichDoc {
  return richDocFrom([{ type: 'p', children: [{ text }] }]);
}

function inlineText(items: RichInline[]): string {
  return items
    .map((item) => {
      if (item.type === 'text') {
        return item.text;
      }
      if (item.type === 'link') {
        return inlineText(item.content);
      }
      return item.type === 'objectRef' ? item.props.label : `@${item.props.handle}`;
    })
    .join('');
}

function ownText(block: RichBlock): string {
  if (block.type === 'file') {
    return String(block.props.name ?? '');
  }
  if (block.table !== undefined) {
    return block.table.rows.flatMap((row) => row.map(inlineText)).join(' ');
  }
  return inlineText(block.content);
}

export function blockTexts(blocks: RichBlock[]): string[] {
  return blocks.flatMap((block) => [ownText(block), ...blockTexts(block.children)]);
}

export function richDocToText(value: unknown): string {
  return blockTexts(richDocFrom(value)).join(' ').replace(/\s+/g, ' ').trim();
}
